import React from "react";

/**
 * Native `ai_solid.svg`; ODS has no equivalent. Sized in `em` so the ODS
 * start-icon sizes apply.
 */
export const IconAi = () => (
  <svg
    aria-hidden="true"
    focusable="false"
    height="1em"
    viewBox="0 0 24 24"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15,6.86c.46,0,.88.24,1.11.63l.09.17,1.38,3.36c.26.63.77,1.14,1.4,1.4l3.36,1.38c.42.17.72.56.79,1l.02.19-.02.19c-.07.44-.36.83-.79,1l-3.36,1.38-.23.11c-.52.28-.94.74-1.17,1.29l-1.38,3.36-.09.17c-.23.38-.65.63-1.11.63-.52,0-1-.32-1.2-.8l-1.38-3.36c-.26-.63-.77-1.14-1.4-1.4l-3.36-1.38-.17-.09c-.38-.23-.63-.65-.63-1.11s.24-.88.63-1.11l.17-.09,3.36-1.38c.55-.23,1.01-.64,1.29-1.17l.11-.23,1.38-3.36.09-.17c.2-.33.53-.55.91-.61l.19-.02ZM6,.86c.39,0,.76.21.95.54l.08.15.59,1.43c.23.55.64,1.01,1.17,1.29l.23.11,1.43.59c.36.15.62.48.68.86v.17s0,.17,0,.17c-.06.38-.31.71-.68.86l-1.43.59-.23.11c-.52.28-.94.73-1.17,1.29l-.59,1.43-.08.15c-.2.33-.56.54-.95.54-.45,0-.86-.27-1.03-.69l-.59-1.43-.11-.23c-.28-.52-.73-.94-1.29-1.17l-1.43-.59-.15-.08c-.33-.2-.54-.56-.54-.95s.21-.76.54-.95l.15-.08,1.43-.59c.55-.23,1.01-.64,1.29-1.17l.11-.23.59-1.43.08-.15c.17-.28.46-.48.79-.53h.17Z"
      fill="currentColor"
    />
  </svg>
);
